import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImportAction } from '../blacklist/blacklist';
import { IState } from '../../shared/models/state';
import { Store } from '@ngrx/store';
import { IMPORT_FILE_TO_BLACKLIST_SUCCESS, ImportFileToBlacklistAction } from '../blacklist/blacklist.actions';
import { convertFilesToSendForm } from '../../shared/utils/file-utils';
import { Actions } from '@ngrx/effects';

@Component({
  selector: 'cc-choose',
  templateUrl: './choose.component.html',
  styleUrls: ['./choose.component.scss']
})
export class ChooseComponent implements OnInit {
  public action: ImportAction;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private action$: Actions,
    private store: Store<IState>
  ) {}

  ngOnInit() {
    this.action = this.route.snapshot.data['action'];
  }

  handleFileInput(files: FileList) {
    this.store.dispatch(
      new ImportFileToBlacklistAction({
        action: this.action,
        fileForm: convertFilesToSendForm(files)
      })
    );
    this.action$
      .ofType(IMPORT_FILE_TO_BLACKLIST_SUCCESS)
      .take(1)
      .subscribe(() => {
        this.router.navigate(['/', 'blacklist']);
      });
  }
}
